<template>
    <button
        type="button"
        class="inline-flex items-center justify-center rounded-lg bg-primary-600 px-3.5 py-1.5 text-lg font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 disabled:bg-gray-400 disabled:cursor-not-allowed"
    >
        <IconsLoadingSpinnerWhite v-if="loading"></IconsLoadingSpinnerWhite>
        <slot />
    </button>
</template>
<script setup lang="ts">
import IconsLoadingSpinnerWhite from "@/components/icons/LoadingSpinnerWhite.vue";
const loading = defineModel("loading", { type: Boolean, default: false });
</script>
